









































































import { Component, Vue } from 'vue-property-decorator';
import {dispatchSubmitPasswordRecovery} from '@/store/main/actions';
// // @ts-ignore
// import backgroundImg from '@/assets/images/login_background_new.jpeg';
// // @ts-ignore
// import backgroundImgX2 from '@/assets/images/login_background_newx2.jpeg';
// @ts-ignore
import backgroundImg from '@/assets/images/bg-2.jpg';
// @ts-ignore
import backgroundImgX2 from '@/assets/images/bg-2.jpg';

@Component({})
export default class PasswordReset extends Vue {
  public resetEmail = '';
  public domain = 'univer4d';
  public resetStep = 1;
  public backgroundImage = backgroundImg;
  public backgroundImageX2 = backgroundImgX2;

  public mounted() {
    this.domain = window.location.host;
  }

  public async submitReset() {
    const response = await dispatchSubmitPasswordRecovery(this.$store, { email: this.resetEmail });
    if (response) {
      this.resetStep = 2;
    } else {
      alert(this.$t('Reset failed').toString());
    }
  }
}

